<template>
<el-form ref="companyForm" :model="cas" :rules="rules" size="small" label-width="120px" class="margin15-tb">
      <el-row :gutter="24">
        <el-col :span="8">
          <el-form-item label="机构名称" prop="companyName">
            <el-input v-model="cas.companyName"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24" v-if="this.$partB()">
        <el-col :span="8">
          <el-form-item label="机构类型" prop="businessType">
            <el-select v-model="cas.businessType" filterable placeholder="请选择" style="width: 100%;">
              <el-option v-for="item in businessTypeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24" v-if="this.$partB()">
        <el-col :span="8">
          <el-form-item label="绑定公司">
            <el-select v-model="cas.pid" filterable clearable  placeholder="请选择" style="width: 100%;">
              <el-option v-for="item in companyNameList" :key="item.id" :label="item.companyName" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="8">
          <el-form-item label="联系电话" prop="telephone">
            <el-input v-model="cas.telephone"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="8">
          <el-form-item label="短信抬头">
            <el-input v-model="cas.messageHead"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="8">
          <el-form-item label="还款银行">
            <el-input v-model="cas.bankName"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="8">
          <el-form-item label="开户人">
            <el-input v-model="cas.bankPeople"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="8">
          <el-form-item label="还款银行卡号">
            <el-input v-model="cas.cardNumber"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="8">
          <el-form-item label="还款信息">
            <el-input type="textarea" v-model="cas.payInfo"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24" v-if="this.$partB()">
        <el-col :span="8">
          <el-form-item label="合同公司名称">
            <el-input v-model="cas.agreementCompanyName" maxlength="20"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="8">
          <el-form-item label="营业执照">
            <el-input v-model="cas.businessLicense"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <!-- <el-row :gutter="24">
        <el-col :span="8">
          <el-form-item label="每日最大导入量" required>
            <div style="display: inline-block">
              <el-input-number :min="-1" :max="99999" v-model="cas.amount" v-if="this.$partB()" placeholder="请输入每日最大导入量" style="width: 85%"/>
              <span v-if="this.$partA()">{{cas.amount}}</span>
            </div>
            <div style="display: inline-block; margin-left: 10px;">
              <el-tooltip class="item" effect="light" placement="right">
                <div slot="content">
                  最大为99999，若为-1则不限制每日导入量<br/>
                  当天已导入{{this.cas.todayAmount}},{{this.cas.amount === -1 ? '无限制' : `剩余${left}`}}
                </div>
                <i class="el-icon-question"></i>
              </el-tooltip>
            </div>
          </el-form-item>
        </el-col>
      </el-row> -->
      <el-row :gutter="24">
        <el-col :span="8">
          <el-form-item label="账号到期日">
            <span v-if="this.$partB()">
              <el-date-picker
                v-model="cas.signEndTime"
                type="datetime"
                placeholder="选择日期时间"
                style="width:100%;"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss" @change="timeChange">
              </el-date-picker>
            </span>
            <span v-else>{{this.cas.signEndTime}}</span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="8">
          <el-form-item label="是否海外公司">
            <el-switch v-model="cas.internationalVersionFlag" active-value="1" inactive-value="0"></el-switch>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24" v-if="cas.internationalVersionFlag === '1'">
        <el-col :span="8">
          <el-form-item label="语言" prop="workLanguage">
            <el-select v-model="cas.workLanguage" filterable placeholder="请选择" style="width: 100%;">
              <el-option v-for="item in workLanguageOptions" :key="item.modelCode" :label="item.modelName" :value="item.modelCode"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-col :span="1" :offset="2">
          <div class="text right">
            <el-button type="primary" size="small" @click="submitCompanyForm" :disabled="isDisable">保存</el-button>
          </div>
        </el-col>
</el-form>
</template>
<script>
export default {
  props: [
    'companyIdTemp', 'companyNameList'
  ],
  data() {
    return {
      cas: {
        companyName: '',
        telephone: '',
        messageHead: '',
        bankName: '',
        bankPeople: '',
        cardNumber: '',
        payInfo: '',
        signEndTime: '',
        agreementCompanyName: null,
        businessLicense: null,
        amount: null,
        todayAmount: null,
        businessType: null,
        pid: null,
        internationalVersionFlag: '0',
        workLanguage: ''
      },
      left: null,
      companyId: null,
      authInfoId: '',
      bankInfoId: '',
      isDisable: false,
      companyType: null,
      businessTypeOptions: [
        {
          value: 'collection',
          label: '催收'
        },
        {
          value: 'marketing',
          label: '营销'
        },
        {
          value: 'fraud',
          label: '反欺诈'
        },
        {
          value: 'collection-two',
          label: '催收场景-02'
        },
        {
          value: 'pos',
          label: '营销POS'
        },
        {
          value: 'insurance',
          label: '保险'
        },
        {
          value: 'return-visit',
          label: '回访'
        },
        {
          value: 'comprehensive-health',
          label: '大健康'
        },
        {
          value: 'education',
          label: '教育'
        },
        {
          value: 'e-commerce',
          label: '电商'
        },
        {
          value: 'car-rental',
          label: '汽车租赁'
        }
      ],
      workLanguageOptions: []
    };
  },
  computed: {
    rules() {
      const rules = {
        companyName: [
          { required: true, message: '请输入机构名称', trigger: 'blur' }
        ],
        telephone: [
          { required: true, message: '请输入联系电话', trigger: 'blur' }
        ],
        businessType: [
          { required: true, message: '请选择机构类型', trigger: 'change' }
        ]
      };

      // 只有当是海外公司时，才添加语言字段的验证规则
      if (this.cas.internationalVersionFlag === '1') {
        rules.workLanguage = [
          { required: true, message: '请选择语言', trigger: 'change' }
        ];
      }

      return rules;
    }
  },
  watch: {
    companyIdTemp(companyId) {
      this.$ajax({
        url: '/company/getCompanyList',
        params: { company: companyId }
      }).then((res) => {
        console.warn('公司信息');
        this.cas.companyName = res.data.authInfo.companyName;
        this.cas.telephone = res.data.authInfo.telephone;
        this.cas.messageHead = res.data.authInfo.messageHead;
        this.cas.bankName = res.data.bankInfo.bankName;
        this.cas.bankPeople = res.data.bankInfo.bankPeople;
        this.cas.cardNumber = res.data.bankInfo.cardNumber;
        this.cas.payInfo = res.data.authInfo.payInfo;
        this.cas.signEndTime = res.data.authInfo.signEndTime;
        this.authInfoId = res.data.authInfo.id;
        this.bankInfoId = res.data.bankInfo.id;
        this.cas.agreementCompanyName = res.data.authInfo.agreementCompanyName;
        this.cas.businessLicense = res.data.authInfo.businessLicense;
        this.cas.amount = res.data.amountInfo.amount;
        this.cas.todayAmount = res.data.amountInfo.todayAmount;
        this.left = this.cas.amount - this.cas.todayAmount;
        this.cas.businessType = res.data.authInfo.businessType;
        this.cas.pid = res.data.authInfo.pid;
        this.cas.internationalVersionFlag = res.data.authInfo.internationalVersionFlag !== undefined && res.data.authInfo.internationalVersionFlag !== null ? String(res.data.authInfo.internationalVersionFlag) : '0';
        this.cas.workLanguage = res.data.authInfo.workLanguage || '';
      }).catch((error) => {
        this.$message({
          type: 'error',
          message: error.message
        });
      });
    }
  },
  methods: {
    // 保存
    submitCompanyForm() {
      this.$refs.companyForm.validate((valid) => {
        if (valid) {
          this.isDisable = true;
          setTimeout(() => {
            this.isDisable = false;
          }, 1000);
          const query = {};
          query.id = this.authInfoId;
          query.bankInfoId = this.bankInfoId;
          query.companyName = this.cas.companyName;
          query.telephone = this.cas.telephone;
          query.messageHead = this.cas.messageHead;
          query.bankName = this.cas.bankName;
          query.bankPeople = this.cas.bankPeople;
          query.cardNumber = this.cas.cardNumber;
          query.payInfo = this.cas.payInfo;
          query.signEndTime = this.cas.signEndTime;
          query.agreementCompanyName = this.cas.agreementCompanyName;
          query.businessLicense = this.cas.businessLicense;
          query.amount = this.cas.amount;
          query.businessType = this.cas.businessType;
          query.pid = this.cas.pid;
          query.internationalVersionFlag = this.cas.internationalVersionFlag;
          query.workLanguage = this.cas.workLanguage;
          this.$ajax({
            prompt: true,
            url: '/company/updateCompanyInfo',
            data: query
          }).then((res) => {
            this.bankInfoId = res.data.id;
            // 更新剩余量
            this.left = this.cas.amount - this.cas.todayAmount;
          });
          return true;
        }
        return false;
      });
    },
    timeChange() {
      console.warn(this.cas.signEndTime);
      const companyEndTime = this.cas.signEndTime;
      if (companyEndTime != null) {
        const nowtime = new Date().getTime();
        const companyEnd = new Date(companyEndTime).getTime();
        if (nowtime > companyEnd) {
          // console.warn('变红');
        } else {
          // console.warn('变白');
        }
      }
    },
    getWorkLanguageOptions() {
      this.$ajax({
        url: '/dict/list/workLanguage',
        method: 'GET'
      }).then((res) => {
        this.workLanguageOptions = res.data;
      });
    }
  },
  mounted() {
    this.getWorkLanguageOptions();
  }
};
</script>




// WEBPACK FOOTER //
// src/page/main/company/company_information.vue